// Deterministic per-district catalog selection.
// FNV-1a 32-bit hash — MUST stay identical to backend/district_content.py fnv1a().
function fnv1a(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}

// Returns a stable, district-unique subset/order of the city's products.
// Same products list + same districtSlug always yields the same result,
// and it matches the backend prerender so bots and users see the same grid.
export function districtCatalog(products, districtSlug, size = 20) {
  if (!Array.isArray(products) || products.length === 0) return products || [];
  const ranked = products
    .map((p) => ({ p, k: fnv1a(`${p.id}#${districtSlug}`) }))
    .sort((a, b) => a.k - b.k || String(a.p.id).localeCompare(String(b.p.id)));
  return ranked.slice(0, Math.min(size, ranked.length)).map((x) => x.p);
}
